import type { ReactNode } from "react";
import { Icon } from "./Icon";
import { Menu } from "./Menu";
import { errorText, useT } from "./i18n";
import { useSession } from "./session";

export function initials(name: string): string {
  const words = name.trim().split(/\s+/u).filter(Boolean);
  return words.length ? [words[0], ...(words.length > 1 ? [words[words.length - 1]] : [])].map((word) => Array.from(word)[0]).join("").toLocaleUpperCase() : "?";
}

/**
 * The name is one entry point; actions remain hidden until the member asks for them. With
 * `memberId`, Block and Hide (PLAN.md 4.16 K9) sit beside Write and View.
 */
export function PersonMenu({ name, children, className = "", onView, onWrite, canWrite, memberId }: {
  name: string; children: ReactNode; className?: string; onView: () => void; onWrite: () => void; canWrite: boolean; memberId?: number;
}) {
  const t = useT();
  const { me, blocked, hidden, blockMember, hideMember } = useSession();
  const other = memberId !== undefined && memberId !== me.id;
  return <Menu label={name} className={`person-trigger ${className}`} trigger={children} items={(close) => {
    const run = (fn: () => Promise<void>) => { close(); fn().catch((err: unknown) => window.alert(errorText(err))); };
    return <>
      <button role="menuitem" disabled={!canWrite} title={!canWrite ? t.design.followToWrite : undefined} onClick={() => { close(); onWrite(); }}><Icon name="write" size={16} />{t.design.sendPrivate}</button>
      <button role="menuitem" onClick={() => { close(); onView(); }}><Icon name="feed" size={16} />{t.design.allMessages(name)}</button>
      {other && <button role="menuitem" onClick={() => run(() => hideMember(memberId, !hidden.has(memberId)))}><Icon name="close" size={16} />{hidden.has(memberId) ? t.design.unhide(name) : t.design.hide(name)}</button>}
      {other && <button role="menuitem" onClick={() => run(() => blockMember(memberId, !blocked.has(memberId)))}><Icon name="lock" size={16} />{blocked.has(memberId) ? t.design.unblock(name) : t.design.block(name)}</button>}
    </>;
  }} />;
}
